import ContactForm from "./ContactForm";
import Footer from "./Footer";

function FormAndFooterView() {
  return (
    <div className="w-screen h-full overflow-y-auto thin-scrollbar">
      <ContactForm />
      <div className="w-full h-3"></div>
      <Footer />
    </div>
  );
}

export default FormAndFooterView;
